window.setAudioFromBytes = (audioId, byteArray) => {
    const audio = document.getElementById(audioId);
    if (!audio || !byteArray) return;

    const blob = new Blob([new Uint8Array(byteArray)], { type: 'audio/mpeg' });
    const url = URL.createObjectURL(blob);

    if (audio._blobUrl) {
        URL.revokeObjectURL(audio._blobUrl);
    }

    audio.src = url;
    audio._blobUrl = url;
    audio.load();
};

window.initAudioEvents = (id, dotNetRef) => {
    const audio = document.getElementById(id);
    if (!audio) return;

    audio._dotNetRef = dotNetRef;

    audio.onended = () => {
        dotNetRef.invokeMethodAsync('OnAudioEnded');
        clearInterval(audio._elapsedInterval);
    };

    audio.onplay = () => {
        clearInterval(audio._elapsedInterval);
        audio._elapsedInterval = setInterval(() => {
            dotNetRef.invokeMethodAsync('UpdateElapsedTime', audio.currentTime);
        }, 1000);
    };

    audio.onpause = () => {
        clearInterval(audio._elapsedInterval);
    };
};

window.toggleAudio = (audioId) => {
    const audio = document.getElementById(audioId);
    if (!audio) return true;

    if (audio.paused) {
        audio.play();
        return false;
    } else {
        audio.pause();
        return true;
    }
};

window.getElementWidth = function (element) {
    return element?.offsetWidth || 0;
};

window.initAudioVisualizer = async function (audioId, canvasId, containerWidth) {
    const audioElem = document.getElementById(audioId);
    const canvas = document.getElementById(canvasId);
    if (!audioElem || !canvas) {
        console.warn("Audio or Canvas not found", audioElem, canvas);
        return;
    }

    audioElem.controls = false;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    const canvasWidth = Math.floor(containerWidth - 100);
    canvas.width = canvasWidth;
    canvas.height = 30;

    const audioCtx = new (window.AudioContext || window.webkitAudioContext)();
    const response = await fetch(audioElem.src);
    const arrayBuffer = await response.arrayBuffer();
    const audioBuffer = await audioCtx.decodeAudioData(arrayBuffer);

    const rawData = audioBuffer.getChannelData(0);
    const samples = 140;
    const blockSize = Math.floor(rawData.length / samples);
    const filteredData = [];
    for (let i = 0; i < samples; i++) {
        let blockStart = i * blockSize;
        let sum = 0;
        for (let j = 0; j < blockSize; j++) {
            sum += Math.abs(rawData[blockStart + j]);
        }
        filteredData.push(sum / blockSize);
    }

    const maxVal = Math.max(...filteredData);
    const spacing = 4;
    const barWidth = (canvas.width - spacing * (samples - 1)) / samples;
    const centerY = canvas.height / 2;

    function drawWaveform(progress) {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        const filledSamples = Math.floor(progress * samples);
        for (let i = 0; i < samples; i++) {
            const val = filteredData[i];
            const height = (val / maxVal) * (canvas.height / 2);
            const x = i * (barWidth + spacing);
            ctx.fillStyle = i < filledSamples ? "#8896F4" : "#8D93A7";
            ctx.fillRect(x, centerY - height, barWidth, height * 2);
        }
    }

    drawWaveform(0);

    audioElem.ontimeupdate = function () {
        const progress = audioElem.currentTime / audioElem.duration;
        drawWaveform(progress);
    };

    canvas.addEventListener("click", function (event) {
        const rect = canvas.getBoundingClientRect();
        const clickX = event.clientX - rect.left;
        const progress = clickX / canvas.width;
        audioElem.currentTime = progress * audioElem.duration;
        drawWaveform(progress);
    });
};

window.createAudioUrl = function (bytes) {
    const blob = new Blob([new Uint8Array(bytes)], { type: 'audio/mpeg' });
    return URL.createObjectURL(blob);
};
